import React, { useContext } from "react";
import { AuthContext } from "./context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    // Show loading indicator while auth status is being restored
    return <div>Loading...</div>;
  }

  if (!user) {
    // If no user, redirect to login
    return <Navigate to="/Login" replace />;
  }

  // If user exists, allow access
  return <Outlet />;
};

export default PrivateRoute;
